"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyIdentifiers$ = exports.PropertyIdentifiers$outboundSchema = exports.PropertyIdentifiers$inboundSchema = void 0;
exports.propertyIdentifiersToJSON = propertyIdentifiersToJSON;
exports.propertyIdentifiersFromJSON = propertyIdentifiersFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const ordnancesurveyidentifiers_js_1 = require("./ordnancesurveyidentifiers.js");
const royalmailidentifiers_js_1 = require("./royalmailidentifiers.js");
/** @internal */
exports.PropertyIdentifiers$inboundSchema = z.object({
    ordnance_survey: z.nullable(ordnancesurveyidentifiers_js_1.OrdnanceSurveyIdentifiers$inboundSchema),
    royal_mail: royalmailidentifiers_js_1.RoyalMailIdentifiers$inboundSchema,
    street_group_property_id: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "ordnance_survey": "ordnanceSurvey",
        "royal_mail": "royalMail",
        "street_group_property_id": "streetGroupPropertyId",
    });
});
/** @internal */
exports.PropertyIdentifiers$outboundSchema = z.object({
    ordnanceSurvey: z.nullable(ordnancesurveyidentifiers_js_1.OrdnanceSurveyIdentifiers$outboundSchema),
    royalMail: royalmailidentifiers_js_1.RoyalMailIdentifiers$outboundSchema,
    streetGroupPropertyId: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        ordnanceSurvey: "ordnance_survey",
        royalMail: "royal_mail",
        streetGroupPropertyId: "street_group_property_id",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PropertyIdentifiers$;
(function (PropertyIdentifiers$) {
    /** @deprecated use `PropertyIdentifiers$inboundSchema` instead. */
    PropertyIdentifiers$.inboundSchema = exports.PropertyIdentifiers$inboundSchema;
    /** @deprecated use `PropertyIdentifiers$outboundSchema` instead. */
    PropertyIdentifiers$.outboundSchema = exports.PropertyIdentifiers$outboundSchema;
})(PropertyIdentifiers$ || (exports.PropertyIdentifiers$ = PropertyIdentifiers$ = {}));
function propertyIdentifiersToJSON(propertyIdentifiers) {
    return JSON.stringify(exports.PropertyIdentifiers$outboundSchema.parse(propertyIdentifiers));
}
function propertyIdentifiersFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PropertyIdentifiers$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PropertyIdentifiers' from JSON`);
}
//# sourceMappingURL=propertyidentifiers.js.map